export const DEBT_STATUS_OPTIONS = [
  'Moroso',
  'En negociación',
  'Acuerdo vigente',
  'Acuerdo vigente - Incumplimiento parcial',
  'Acuerdo vigente - Incumplimento total',
  'En revisión',
];

export const DEBT_STATUS_POSSESSOR_OPTIONS = [
  { label: 'Todos', value: 'all' },
  { label: 'Poseedor', value: 'true' },
  { label: 'No poseedor', value: 'false' },
];

export const DEBT_STATUS_ORDER_OPTIONS = [
  { label: 'Importe mora ⬇', value: 'importe_mora_desc' },
  { label: 'Importe mora ⬆', value: 'importe_mora_asc' },
  { label: 'Cupones en mora ⬇', value: 'cupones_mora_desc' },
  { label: 'Cupones en mora ⬆', value: 'cupones_mora_asc' },
  { label: 'Num. contrato ⬆', value: 'contract_number_asc' },
  { label: 'Num. contrato ⬇', value: 'contract_number_desc' },
];
